import { useEffect } from "react"
import { Card, Col, Container, Row } from "react-bootstrap"
import { useNavigate, useSearchParams } from "react-router-dom"
import { processQrCodeAsString } from "shared/barcode"
import IconText from "ui/components/IconText"
import { STANDARD_SPACING } from "ui/config"
import { QR_CODE_ICON } from "ui/icons"
import QRReader from "ui/qr/QRReader"
import useTitlePart from "ui/title/useTitlePart"
import { useAnonymous } from "./index.js"

export default function Scan() {
    const navigate = useNavigate()
    useTitlePart("Scan Asset")
    const [search] = useSearchParams()
    const name = search.get("name") ?? undefined
    const companyName = search.get("companyName") ?? undefined
    const [_anonymous, setAnonymous] = useAnonymous()
    useEffect(() => {
        if (name === undefined || companyName === undefined) {
            return
        }
        setAnonymous({ name, companyName })
    }, [
        name,
        companyName,
    ])
    return (
        <div className="d-flex flex-column flex-grow-1 justify-content-center align-items-center bg-light">
            <Container>
                <Row>
                    <Col></Col>
                    <Col lg={6} md={8}>
                        <Card>
                            <Card.Header className={"p-" + STANDARD_SPACING}>
                                <h5 className="mb-0">
                                    <IconText {...QR_CODE_ICON} children="Scan QR Code" />
                                </h5>
                            </Card.Header>
                            <Card.Body className="pb-0">
                                <QRReader setValue={qrCode => navigate("../" + processQrCodeAsString(qrCode))} fullSize />
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col></Col>
                </Row>
            </Container>
        </div>
    )
}
